import { useColorPlacementOptional } from '@/contexts/color-placement-context'
import { colorFillTargets } from '@/lib/colors/color-fill-targets'
import {
  type UsePlacementCanvasBridgeArgs,
  usePlacementCanvasBridge,
} from '@/hooks/use-placement-canvas-bridge'

type ColorPlacementCanvasBridgeProps = Omit<
  UsePlacementCanvasBridgeArgs,
  'placement' | 'isBlockedByTextChain' | 'isDropTarget'
>

/**
 * Registers the canvas's geometry and drop-target hit test with the color placement provider.
 * Unlike photo/ClikArt, color drops are never blocked by linked text chains (a fill color does
 * not replace text content) and target a broader set of shapes (any fillable shape, including
 * ovals). A group is a target when any member can take the fill (`colorFillTargets`); the drop
 * then recolors all of them.
 */
export function ColorPlacementCanvasBridge(props: ColorPlacementCanvasBridgeProps) {
  usePlacementCanvasBridge({
    ...props,
    placement: useColorPlacementOptional(),
    isBlockedByTextChain: () => false,
    isDropTarget: (shape) =>
      colorFillTargets([shape], props.shapeManagerRef.current?.getShapes() ?? []).length > 0,
  })

  return null
}
